import * as R from "ramda";

import { getChatbotStatus } from "../../scenes/Opportunity/routes/OpportunityProcess/selectors";
import i18n from "../../i18n";

export const INITIAL_CHATBOT_VALIDATION_PATH = [
  "config",
  "chatTree",
  "questions"
];

export const getErrorText = value => {
  if (!value) return i18n.t("form:emptyFieldValidation");

  if (value.length <= 1)
    return i18n.t("opportunity:process.stepTypes.chatbot.lengthValidation");

  if (
    R.any(
      R.both(
        R.propSatisfies(
          R.when(R.is(Array), children => R.length(children) < 2),
          "children"
        ),
        R.propEq("type", "options")
      )
    )(value)
  )
    return i18n.t(
      "opportunity:process.stepTypes.chatbot.branchLengthValidation"
    );
};

export const getError = (_, value, callback) => {
  return callback(getErrorText(value));
};

export const getWarning = (step, candidatesList) => {
  if (!R.hasPath(["columnOrder"], step)) {
    return false;
  }

  const isCandidateChatbotPending = R.pipe(
    R.values,
    R.any(candidate => getChatbotStatus(step, candidate) === "PENDING")
  )(candidatesList);

  if (!R.isNil(step.columnOrder) && isCandidateChatbotPending) {
    return i18n.t(
      "opportunity:process.stepTypes.chatbot.chatbotPendingValidation"
    );
  }

  return false;
};
